/*
 * @Description: 订单
 * @Date: 2025-06-12 17:32:33
 */

// 支付方式
export const PAY_TYPE = {
  1: { label: '线上支付', value: 1 },
  2: { label: '线下支付', value: 2 }
};
// 支付状态
export const RECEIVE_STATUS = {
  0: { label: '未支付', value: 0 },
  1: { label: '支付中', value: 1 },
  2: { label: '支付成功', value: 2 },
  3: { label: '支付失败', value: 3 }
};
// TODO: STATE_TYPE ORDER_TYPE都需要重新定义
// 名字有问题，应该是全费用类型，该类型为发票类型！
export const STATE_TYPE = {
  1: { label: '汇总申报', value: 1 },
  2: { label: '委托代开(线上)', value: 2 },
  3: { label: '园区个体', value: 3 },
  4: { label: '平台服务费', value: 4 },
  5: { label: '商务服务费', value: 5 },
  6: { label: '综合服务费', value: 6 },
  7: { label: '个体产品', value: 7 },
  8: { label: '技术服务费', value: 8 },
  9: { label: '个体平台服务费', value: 9 },
  10: { label: '个体税金及服务费发票', value: 10 }
};
// 这个名字有问题，这个应该是平台费用类型
export const ORDER_TYPE = {
  1: { label: '项目服务费', value: 1 }, // 等于STATE_TYPE中的1|2|3|7
  4: { label: '平台服务费', value: 4 },
  5: { label: '商务服务费', value: 5 },
  6: { label: '综合服务费', value: 6 }, // （返佣）
  8: { label: '技术服务费', value: 8 },
  9: { label: '个体平台服务费', value: 9 },
  10: { label: '个体税金及服务费发票', value: 10 }
};
export const PAY_STATUS = {
  0: { label: '未支付', value: 0 },
  1: { label: '支付中', value: 1 },
  2: { label: '支付成功', value: 2 },
  3: { label: '支付失败', value: 3 },
  4: { label: '线下支付完成', value: 4 },
  5: { label: '关闭支付', value: 5 }
};
